// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableDiscovery_Component__bdqqv"};